<template>
  <div>
    <div :key="item.master.id" v-for="item in masters">
      <div v-if="service === item.master.service_id">
        <div class="row row--service">
          <div class="row__name row__name_w156 row__name--service z-5">
            <div
              class="row--image"
              :style="{
                backgroundImage: 'url(' + item.master.small_image + ')',
              }"
            ></div>
            {{ item.master.first_name }} {{ item.master.last_name }}
          </div>

          <calendar-day-time />

          <div
            class="master-schedule"
            v-if="item.schedule.workday"
            :style="{
              width: calculateSchedule(item).width,
              left: calculateSchedule(item).left,
            }"
          ></div>

          <div class="master-onlines" v-if="item.shift.time_start != null">
            <div
              class="master-online"
              :style="{
                  width: getOnline(item.shift).width,
                  left: getOnline(item.shift).left,
                }"
            ></div>
          </div>

          <div class="master-orders" v-if="item.requests.length !== 0">
            <div
              class="master-order"
              v-for="request in item.requests"
              @click="openOrderModal(request.request_id)"
              :style="{
                width: `${calculateOrder(request).width}`,
                left: `${calculateOrder(request).left}`,
              }"
              :key="request.request_id"
            >
              <template v-if="service === request.service_id">
                <div
                  class="master-order__actual master-order__actual-start"
                  :style="{
                    left: getOrderWidth(request).early.before.offset,
                    width: getOrderWidth(request).early.before.width,
                    'background-color': '#BEB4DC',
                  }"
                ></div>

                <div
                  class="master-order__actual master-order__actual-end"
                  :style="{
                    right: getOrderWidth(request).early.after.offset,
                    width: getOrderWidth(request).early.after.width,
                    'background-color': '#BEB4DC',
                  }"
                ></div>

                <div
                  class="master-order__late master-order__late-start"
                  :style="{
                    left: getOrderWidth(request).late.before.offset,
                    width: getOrderWidth(request).late.before.width,
                    'background-color': 'red',
                    'z-index': 5,
                  }"
                ></div>
                <div
                  class="master-order__late master-order__late-end"
                  :style="{
                    right: getOrderWidth(request).late.after.offset,
                    width: getOrderWidth(request).late.after.width,
                    'background-color': 'red',
                    'z-index': 6,
                  }"
                ></div>
              </template>
            </div>
          </div>

          <div class="statistic2">
            <div class="statistic2-row">
              <div class="statistic2-row__box">
                <div
                  class="statistic2-row__percent"
                  :style="{
                    'background-color': getStatisticColors(
                      item.metrics.indicator_1
                    ),
                    height: `${item.metrics.indicator_1}%`,
                  }"
                ></div>
                <p
                  class="statistic2-row__percent-text"
                  :style="{
                    color: getStatisticColors(item.metrics.indicator_1),
                  }"
                >{{ item.metrics.indicator_1 }}%</p>
              </div>
            </div>

            <div class="statistic2-row">
              <div class="statistic2-row__box">
                <div
                  class="statistic2-row__percent"
                  :style="{
                    'background-color': getStatisticColors(
                      item.metrics.indicator_2
                    ),
                    height: `${item.metrics.indicator_2}%`,
                  }"
                ></div>
                <p
                  class="statistic2-row__percent-text"
                  :style="{
                    color: getStatisticColors(item.metrics.indicator_2),
                  }"
                >{{ item.metrics.indicator_2 }}%</p>
              </div>
            </div>

            <div class="statistic2-row">
              <div class="statistic2-row__box">
                <div
                  class="statistic2-row__percent"
                  :style="{
                    'background-color': getStatisticColors(
                      item.metrics.indicator_3
                    ),
                    height: `${item.metrics.indicator_3}%`,
                  }"
                ></div>
                <p
                  class="statistic2-row__percent-text"
                  :style="{
                    color: getStatisticColors(item.metrics.indicator_3),
                  }"
                >{{ item.metrics.indicator_3 }}%</p>
              </div>
            </div>

            <div class="statistic2-row">
              <div class="statistic2-row__box">
                <div
                  class="statistic2-row__percent"
                  :style="{
                    'background-color': getStatisticColors(
                      item.metrics.indicator_4
                    ),
                    height: `${item.metrics.indicator_4}%`,
                  }"
                ></div>
                <p
                  class="statistic2-row__percent-text"
                  :style="{
                    color: getStatisticColors(item.metrics.indicator_4),
                  }"
                >{{ item.metrics.indicator_4 }}%</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import getColor from '@/mixins/getStatisticColors'
import calendarDayTime from '@/components/calendars/day/calendarDayTime'
// import calendar from "@/mixins/calendar";

export default {
    name: 'calendar-schedule',
    props: {
        masters: {
            required: true,
        },
    },
    components: {
        calendarDayTime,
    },
    mixins: [getColor],
    data() {
        return {}
    },
    computed: {
        ...mapGetters({
            dayGetters: 'dayGetters',
            service: 'serviceGetters',
        }),
    },
    methods: {
        ...mapActions({
            fetchById: 'orders/fetchById',
        }),
        ...mapMutations({
            setToggleModal: 'orders/setToggleModal',
        }),
        calculateSchedule(item) {
            const defaultData = {
                width: '0%',
                left: '0%',
            }

            if (item.schedule.time_from === null) {
                return defaultData
            }

            const today = new Date(this.dayGetters)

            const from = new Date(
                `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDay()} ${
                    item.schedule.time_from
                }`,
            ).getHours()
            const till = new Date(
                `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDay()} ${
                    item.schedule.time_till
                }`,
            ).getHours()

            const p10 = document.querySelectorAll('.row__times')[0].offsetWidth / 24

            return {
                left: `calc(${from * p10}px + 156px)`,
                width: `${(till - from) * p10}px`,
            }
        },
        calculateOrder(item) {
            // const start = 8;
            // const end = 19;

            const p10 = document.querySelectorAll('.row__times')[0].offsetWidth / 24

            const from = new Date(item.schedule_from).getHours()
        + new Date(item.schedule_from).getMinutes() / 60
            const to = new Date(item.schedule_till).getHours()
        + new Date(item.schedule_till).getMinutes() / 60

            return {
                width: `${(to - from) * p10}px`,
                left: `calc(${from * p10}px + 156px)`,
            }
        },
        async openOrderModal(v) {
            await this.fetchById(v)
            this.setToggleModal()
        },
        getOrderWidth(item) {
            const p10 = document.querySelectorAll('.row__times')[0].offsetWidth / 24

            // late width
            const from = new Date(item.schedule_from).getHours()
        + new Date(item.schedule_from).getMinutes() / 60
            const fact_from = new Date(item.fact_from).getHours()
        + new Date(item.fact_from).getMinutes() / 60
            const startFact = (fact_from - from) * p10

            // delay width
            const till = new Date(item.schedule_till).getHours()
        + new Date(item.schedule_till).getMinutes() / 60
            const fact_till = new Date(item.fact_till).getHours()
        + new Date(item.fact_till).getMinutes() / 60

            const tillFact = (till - fact_till) * p10

            const defaultData = {
                early: {
                    before: {
                        offset: '0',
                        width: '0',
                    },
                    after: {
                        offset: '0',
                        width: '0',
                    },
                },
                late: {
                    before: {
                        offset: '0',
                        width: '0',
                    },
                    after: {
                        offset: '0',
                        width: '0',
                    },
                },
            }

            if (Math.sign(startFact) === -1) {
                defaultData.early.before.offset = `${startFact}px`
                defaultData.early.before.width = `${startFact * -1}px`
            } else {
                defaultData.late.before.offset = 0
                defaultData.late.before.width = `${startFact}px`
            }

            if (Math.sign(tillFact) === 1) {
                defaultData.early.after.offset = 0
                defaultData.early.after.width = `${tillFact}px`
            } else {
                defaultData.late.after.offset = `${tillFact}px`
                defaultData.late.after.width = `${tillFact * -1}px`
            }

            return defaultData
        },
        getOnline({ time_start, time_end }) {
            const p10 = document.querySelectorAll('.row__times')[0].offsetWidth / 24

            const today = new Date(this.dayGetters)
            const from = new Date(
                `${today.getFullYear()}-${today.getMonth()
          + 1}-${today.getDay()} ${time_start}`,
            )
            const to = new Date(
                `${today.getFullYear()}-${today.getMonth()
          + 1}-${today.getDay()} ${time_end}`,
            )

            const factFrom = from.getHours() + from.getMinutes() / 60
            const width = to.getHours() + to.getMinutes() / 60
            console.log(factFrom, width, from, to)
            return {
                width: `${(width - factFrom) * p10}px`,
                left: `${factFrom * p10 + 156}px`,
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import "src/assets/sass/main";
</style>
